import React, { useState, useEffect, useCallback } from "react";

interface RetryImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  /** Número máximo de reintentos */
  maxRetries?: number;
  /** Milisegundos entre cada intento */
  retryDelay?: number;
  /** Texto a mostrar mientras carga */
  loadingText?: string;
}

const RetryImage: React.FC<RetryImageProps> = ({
  src,
  alt,
  maxRetries = 5,
  retryDelay = 3000,
  loadingText = "cargando imagen...",
  ...imgProps
}) => {
  const [currentSrc, setCurrentSrc] = useState(src);
  const [attempt, setAttempt] = useState(0);
  const [loaded, setLoaded] = useState(false);

  const host = process.env.REACT_APP_API_URL_IMG
    ? process.env.REACT_APP_API_URL_IMG
    : "";

  // Al cambiar la URL original, reiniciamos estados
  useEffect(() => {
    // calgulamos la url como la suma de host + src si no tiene http el src
    if (!src) {
      setCurrentSrc("");
      setLoaded(false);
      return;
    }
    if (src.startsWith("http")) {
      setCurrentSrc(src);
    } else {
      setCurrentSrc(host + src);
    }
    setAttempt(0);
    setLoaded(false);
  }, [src]);

  const handleError = useCallback(() => {
    if (attempt < maxRetries) {
      setTimeout(() => {
        setAttempt(at => at + 1);
        // anti-caché
        setCurrentSrc(`${currentSrc}?_retry=${Date.now()}`);
      }, retryDelay);
    } else {
      console.warn(`No se pudo cargar tras ${maxRetries} intentos: ${currentSrc}`);
    }
  }, [attempt, maxRetries, retryDelay, currentSrc]);

  const handleLoad = () => {
    setLoaded(true);
  };

  return (
    <>
      {!loaded && (
        <p style={{ margin: 0, paddingTop: "4em", color: "#666", minHeight: "10em", textAlign: "center", verticalAlign: "middle", fontWeight: "bold", minWidth: "300px", maxWidth: "300px" }}>
          {loadingText}
        </p>
      )}
      <img
        className="file-input-img"
        {...imgProps}
        src={currentSrc}
        alt={alt}
        onError={handleError}
        onLoad={handleLoad}
        style={{
          display: loaded ? "block" : "none",
          width: "100%",
          height: "auto",
        }}
      />
    </>
  );
};

export default RetryImage;
